import React from 'react';
import { Stack, Box, Text, Heading, Link } from '@chakra-ui/react';
import CollapsibleItems from '../common/CollapsibleItems';

const FAQ_ITEMS = [
  {
    title: 'What is a facet?',
    content:
      'A facet is one section (plane or surface) of a multi-sectioned roof that is over 4 square feet. We calculate a property price using the complexity of a roof, based on the number of roof facets.',
  },
  {
    title:
      'Do I need to put a credit card on file when downloading Beacon 3D+?',
    content: (
      <Stack spacing="3">
        <Text>
          No, you can start using Beacon 3D+ without putting a credit card on
          file.
        </Text>

        <Text>
          Your first job is included for free, but you need to add a credit card
          to your account to process subsequent jobs.
        </Text>
      </Stack>
    ),
  },
  {
    title: 'Is there a monthly cost associated with Beacon 3D+?',
    content:
      'Beacon 3D+ pricing is a combination of a SaaS-based subscription plus per-job transactional charges. This entitles you to advanced features and volume discounts. If a membership is not right for you, you have the option to pay as you go on a per-property basis.',
  },
  {
    title: 'Can I try out a membership plan for free?',
    content:
      'Yes, you can start a free 30 day trial of the Measure Plan. Your first job is included for free, and you need to add a credit card to your account to process subsequent jobs.',
  },
  {
    title: 'How much does it cost to sign up with Beacon 3D+?',
    content:
      'You can download the Beacon 3D+ app from the App Store or Google Play at no cost. You’ll also receive your first property for free so you can try Beacon 3D+ 100% risk-free.',
  },
  {
    title: 'How can I receive access to volume discounts?',
    content: (
      <Text>
        If you sign up for one of our membership plans, you would receive per
        job discounts of $10-$15, depending on which plan you selected. Give us
        a call at (888) 868-8279 or&nbsp;
        <Link href="https://calendly.com/hover-sdr/hover-membership-website">
          schedule a time to chat
        </Link>
        .
      </Text>
    ),
  },
];

const FAQSection = () => (
  <Box backgroundColor="gray.50" p="5">
    <Box maxW="5xl" mx="auto">
      <Heading mt="14" mb="20" textAlign="center" fontSize="3xl">
        Frequently Asked Questions
      </Heading>
      <CollapsibleItems items={FAQ_ITEMS} isUnderlined />

      <Text textAlign="center" my="16" fontSize="lg">
        Still have questions? Reach out to our&nbsp;
        <Link href="https://hover.to/contact/">Support Team</Link> for help.
      </Text>
    </Box>
  </Box>
);

export default FAQSection;
